import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppRoutes } from '@core';
import { catchError, from, map, Observable, switchMap, throwError } from 'rxjs';
import { AuthService } from '../../infrastructure';
import { buildFirebaseAuthError } from '../utils';

@Injectable({ providedIn: 'root' })
export class AuthWithAppleHandler {
  private readonly authService: AuthService = inject(AuthService);
  private readonly router: Router = inject(Router);
  private readonly translate: TranslateService = inject(TranslateService);

  handle(): Observable<void> {
    return from(this.authService.loginWithApple()).pipe(
      switchMap(() => from(this.router.navigateByUrl(`/${AppRoutes.ROOT}`))),
      map(() => void 0),
      catchError((err: { code?: string; message?: string }) =>
        throwError(() => buildFirebaseAuthError(err, this.translate))
      )
    );
  }
}
